import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.li`
  padding: 10px 8px;
  border-bottom: 1px solid ${COLOR.grayScale_200};
  list-style: none;

  ${mobile(css`
    padding: 10px 0px;
  `)}

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    ${mobile(css`
      border-bottom: 0;
    `)}
  }

  h4 {
    ${setFontStyle("Head6", "Bold")};
    color: ${COLOR.grayScale_800};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .board-contents-info {
    margin-top: 8px;
    color: ${COLOR.grayScale_700};
  }

  .date,
  .writer {
    ${setFontStyle("Body8")};
  }

  .date {
    margin-right: 8px;
  }
`;

export default {
  container,
};
